import { AlertTriangle } from 'lucide-react';

export const BetaBanner = () => {
  return (
    <div className="bg-amber-50 border-b border-amber-200 px-4 py-2 text-center sticky top-0 z-[60]">
      <p className="text-sm text-amber-800 flex items-center justify-center gap-2">
        <AlertTriangle className="w-4 h-4 flex-shrink-0" />
        <span>
          <strong>NexusAI is in private beta.</strong> Please do not enter confidential company data.
        </span>
      </p>
    </div>
  );
};
